import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";

import { FileUpload } from "@/components/shared/FileUpload";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { TenantCurrentResponse } from "@/services/authService";

export interface PersonalizeStepProps {
  tenant: TenantCurrentResponse;
  legalName: string;
  setLegalName: (v: string) => void;
  onLogoFileChange: (file: File | null) => Promise<void>;
  uploadingLogo: boolean;
}

export function PersonalizeStep({
  tenant,
  legalName,
  setLegalName,
  onLogoFileChange,
  uploadingLogo,
}: PersonalizeStepProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Card>
      <CardContent className="space-y-4 pt-6">
        <div className="grid gap-2">
          <Label htmlFor="legalName">{t("onboarding.fantasyNameLabel")}</Label>
          <Input
            id="legalName"
            value={legalName}
            onChange={(e) => setLegalName(e.target.value)}
            placeholder={t("onboarding.fantasyNamePlaceholder")}
          />
        </div>
        <div>
          <FileUpload
            key={tenant.profileImage ?? tenant.invoiceLogoImage ?? "default"}
            currentImageUrl={tenant.profileImage ?? tenant.invoiceLogoImage}
            onFileChange={onLogoFileChange}
            disabled={uploadingLogo}
            label={t("onboarding.logoUploadLabel")}
            helperText={t("onboarding.logoUploadHint")}
            acceptedMimeTypes={["image/jpeg", "image/png"]}
          />
          {uploadingLogo && (
            <div className="mt-2 flex items-center gap-2 text-sm text-muted-foreground">
              <Loader2 className="h-4 w-4 animate-spin" />
              <span>{t("onboarding.saving")}</span>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
